import { WithClassName } from 'src/utils/UtilityTypes';
import { SpotMarketConfig } from '@velocity-exchange/sdk';
import { cj } from 'src/utils/classNames';
import { UIMarket } from '@velocity-exchange/common';
import useCurrentWalletCollateralBalance from 'src/hooks/useCurrentWalletCollateralBalance';

export const CardAssetBalance = ({
	marketIndex,
	className,
}: { marketIndex: number } & WithClassName) => {
	const spotMarketConfig = UIMarket.createSpotMarket(marketIndex);
	const [assetBalance] = useCurrentWalletCollateralBalance(
		spotMarketConfig.market as SpotMarketConfig
	);
	return (
		<div
			className={cj(
				'flex flex-row items-center gap-x-xs typo-body-xs text-text-default',
				className
			)}
		>
			<span className="text-text-secondary">Wallet Balance</span>
			<span className="text-text-default">
				{assetBalance.toMillified()}{' '}
				{spotMarketConfig.uiSymbols.baseAssetDisplaySymbol}
			</span>
		</div>
	);
};
